export const RHYTHM_OPTIONS = [
  {
    value: 7,
    label: 'Very close',
    shortLabel: 'Weekly',
    helper: 'Keep this bond warm every week.',
  },
  {
    value: 14,
    label: 'Close rhythm',
    shortLabel: 'Often',
    helper: 'A light touch every couple of weeks.',
  },
  {
    value: 30,
    label: 'Warm monthly',
    shortLabel: 'Monthly',
    helper: 'Good for friends and active weak ties.',
  },
  {
    value: 60,
    label: 'Occasional',
    shortLabel: 'Sometimes',
    helper: 'Check in when life gives a natural opening.',
  },
  {
    value: 90,
    label: 'Loose tie',
    shortLabel: 'Seasonal',
    helper: 'A seasonal touch is enough.',
  },
  {
    value: 180,
    label: 'Rarely',
    shortLabel: 'Rarely',
    helper: 'Only a few times a year.',
  },
];

export const getRhythmOption = (value) => {
  if (!value) return RHYTHM_OPTIONS[2];

  return RHYTHM_OPTIONS.reduce((closest, option) => {
    const currentDistance = Math.abs(option.value - Number(value));
    const closestDistance = Math.abs(closest.value - Number(value));
    return currentDistance < closestDistance ? option : closest;
  }, RHYTHM_OPTIONS[2]);
};

export const getRhythmLabel = (value) => getRhythmOption(value).label;

export const getRhythmHelper = (value) => getRhythmOption(value).helper;
